<template>
  <div class="row no-wrap q-gutter-x-sm">
    <re-date-time-picker
      v-model="dateFromFilter"
      :show-time="false"
      placeholder="From"
      size="sm"
      :label="showLabel ? col.label : undefined"
      :hide-bottom-space="!showLabel"
      @update:model-value="updateModel"
    />
    <re-date-time-picker
      v-model="dateToFilter"
      :show-time="false"
      placeholder="To"
      size="sm"
      hide-bottom-space
      @update:model-value="updateModel"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

import { DateFilter } from '@/composables/useRequestList'

import { DashboardColumn } from '../Base/core/builder'

defineProps<{
  col: DashboardColumn
  showLabel?: boolean
}>()

const model = defineModel<DateFilter | null>({
  default: null,
})

const dateFromFilter = ref<Date | string | null>(null)
const dateToFilter = ref<Date | string | null>(null)

function updateModel() {
  model.value = {
    from: dateFromFilter.value,
    to: dateToFilter.value,
    type: 'date',
  }
}

watch(
  () => model.value,
  (newVal) => {
    dateFromFilter.value = newVal?.from ?? null
    dateToFilter.value = newVal?.to ?? null
  },
  { immediate: true }
)
</script>
